import { productionSiteCalendarSlice, callTypes } from "./ProductionSiteCalendarSlice";
import { createDetailedAlert } from "../../utils/DetailedAlert";
import { deleteProductionSiteOverride, getProductionSiteCalendar, putProductionSiteOverride, putProductionSiteWeekDays } from "../api/ProductionSiteCalendarApi";
import { OverrideDate } from "../models/ProductionSiteCalendarModel";

const { actions: sliceActions } = productionSiteCalendarSlice;

export const dismissAlert = () =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.dismissAlert());
    };

export const fetchProductionSiteCalendar = (plantCode: string) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.get }));
        return getProductionSiteCalendar(plantCode)
            .then(response => {
                const productionSites = response
                dispatch(sliceActions.productionSiteCalendarFetched(productionSites));
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on GET for Production Site Calendar")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.get }));
            });
    };

export const saveProductionSiteWeekDays = (plantCode: string, weekdays: string[]) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.put }));
        return putProductionSiteWeekDays(plantCode, weekdays)
            .then(() => {
                dispatch(sliceActions.endCall({ callType: callTypes.put }));
                dispatch(fetchProductionSiteCalendar(plantCode));
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on PUT for Production Site Weekdays")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.put }));
            });
    };

export const saveProductionSiteCalendarOverride = (plantCode: string, override: OverrideDate) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.put }));
        return putProductionSiteOverride(plantCode, override)
            .then(() => {
                dispatch(sliceActions.endCall({ callType: callTypes.put }));
                dispatch(fetchProductionSiteCalendar(plantCode));
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on PUT for Production Site Calendar Override")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.put }));
            });
    };

export const removeProductionSiteCalendarOverride = (plantCode: string, date: string) =>
    async (dispatch: (arg0: any) => void) => {
        dispatch(sliceActions.startCall({ callType: callTypes.delete }));
        return deleteProductionSiteOverride(plantCode, date)
            .then(() => {
                dispatch(sliceActions.endCall({ callType: callTypes.delete }));
                dispatch(fetchProductionSiteCalendar(plantCode));
            })
            .catch(err => {
                const alert = createDetailedAlert(err, "Failure on PUT for Production Site Calendar Override")
                dispatch(sliceActions.catchError({ alert, callType: callTypes.delete }));
            });
    };
